import {conditionVariables} from '../../utils/conditions.js'
import type {ConditionType} from '../../utils/conditions.js'

/** The variables of a parcel for a condition and their types, the value comes from getParcelConditionValue (parcels.ts) */
export const PARCEL_CONDITION_TYPES = {
    weight: 'number',
    length: 'number',
    width: 'number',
    height: 'number',
    volume: 'number',
    options: 'list',
    country: 'choice',
    deliveryZone: 'choice',
    postalCode: 'postalCode',
    isBusiness: 'boolean'
} as const satisfies Record<string, ConditionType>

export type ParcelConditionVariable = keyof typeof PARCEL_CONDITION_TYPES

export const PARCEL_CONDITION_VARIABLES = conditionVariables(PARCEL_CONDITION_TYPES)
